export default __webpack_public_path__ + "static/media/Magadhi_df_1.49eb6b16.mp3";